import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    autoDismiss: { type: Boolean, default: true },
    timeout: { type: Number, default: 6000 }
  }

  connect() {
    if (!this.element) return
    if (this.autoDismissValue) {
      this.timer = setTimeout(() => this.dismiss(), this.timeoutValue)
    }
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  dismiss(event) {
    if (event) event.preventDefault()
    if (this.timer) clearTimeout(this.timer)
    this.element.remove()
  }
}